export default class ConfigPlayerModel {
  constructor() {
    this.playerad = false;
    this.AOVPre = false;
    this.AOVPos = false;
    this.meta = false;
    this.floatPosition = 0;
    this.floatMargin = 10;
    this.floatWidthMobile = 150;
    this.floatWidthDesktop = 324;
  }

  setPlayerAd(playerAd) {
    this.playerad = playerAd;
    return this;
  }

  setAOVPre(AOVPre) {
    this.AOVPre = AOVPre;
    return this;
  }

  setAOVPos(AOVPos) {
    this.AOVPos = AOVPos;
    return this;
  }

  setMeta(meta) {
    this.meta = meta;
    return this;
  }

  setFloatMargin(floatMargin) {
    this.floatMargin = floatMargin;
    return this;
  }

  setFloatWidthMobile(widthMobile) {
    this.floatWidthMobile = widthMobile;
    return this;
  }

  setFloatWidthDesktop(widthDesktop) {
    this.floatWidthDesktop = widthDesktop;
    return this;
  }

  setFloatPosition(position) {
    this.floatPosition = position;
    return this;
  }

  build() {
    return {
      playerad: this.playerad,
      AOVPre: this.AOVPre,
      AOVPos: this.AOVPos,
      meta: this.meta,
      floatMargin: this.floatMargin,
      floatWidthMobile: this.floatWidthMobile,
      floatWidthDesktop: this.floatWidthDesktop,
      floatPosition: this.floatPosition,
    };
  }
}
